import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private snackbarref: any;
  constructor(private _snackbar: MatSnackBar) { }

  showMessage(message: string, duration: number = 4000): void {
    this._snackbar.open(message, ' ', { duration: duration, horizontalPosition: 'start', verticalPosition: 'bottom', panelClass: ['custom-snackbar'] })
  }

  showErrorMessage(message:string,duration:number=4000):void{
    this._snackbar.open(message, ' ', { duration: duration, horizontalPosition: 'start', verticalPosition: 'bottom', panelClass: ['custom-snackbar','error-snackbar'] })
  }

  dismissSnackbar() {
    if (this.snackbarref) {
      this.snackbarref.dismiss();
    }
  }
}
